import { postPriceSchemeRequest, ICreatePriceSchemeRequestBody } from 'src/utils/priceSchemes/postPriceSchemeRequest';
import { API_URL } from '../constants';

export const createPriceScheme = async (requestBody: ICreatePriceSchemeRequestBody) => {
  return postPriceSchemeRequest(`${API_URL}/pricing/schemes`, JSON.stringify(requestBody));
};
